'use client';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function ProductDetailAvailability() {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);
  const product = useVariantsStore(state => state.product);
  const { t } = useTranslations();

  const hasVariants = (product?.variants?.length ?? 0) > 0;
  const activeItem = hasVariants ? (selectedVariant ?? product) : product;

  const availability = selectedVariant?.availability ?? product?.availability;

  const isAvailable = availability?.id === 1;

  if (isAvailable)
    return (
      <div className={cn('flex items-center justify-start gap-2')}>
        <p className={cn('h6', 'font-medium tracking-tighter text-foreground')}>{t('text237')}</p>
        <div
          className="flex h-8 w-auto items-center justify-center rounded-full px-4 text-xs font-medium sm:h-[34px] sm:text-sm"
          style={{
            backgroundColor: activeItem?.availability?.color ?? '#000',
            color: activeItem?.availability?.color_text ?? '#fff',
          }}
        >
          {activeItem?.availability?.name}
        </div>
      </div>
    );
}
